import './style.css';
import {enableZoom} from './zoom';
import {fetchAndParseYAML} from './yml';
import {addAttack} from "./ui";
import * as Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import {getBubble} from "./bubble";
import {enableDragging} from "./drag";

// Initialize the highcharts-more module
// alert(HighchartsMore);
// console.log(window.HighchartsMore);
// HighchartsMore(Highcharts);



function hello() {
    console.log("hello");
}


const modal = document.getElementById('countryModal');

const input2 = document.getElementById('countryInput');

let svgContainer = document.getElementById('svgContainer');
let svgLoaded = false;

const stixGroups = {};
const originCountries = {};
let maxGroupsInACountry = 0;
let observedCountries = {}

async function load() {
    const response = await fetch("tidal-groups.json");
    const tidalData = await response.json();
    console.log(tidalData);
    const stix = await fetchAndParseYAML('extracted-mitre-stix.yml');
    Object.keys(stix).forEach(k => {
        stixGroups[stix[k].group_mitre_id] = stix[k];
    })

    console.log(stixGroups);


    function updateMax(proposed) {
        if (proposed > maxGroupsInACountry) {
            maxGroupsInACountry = proposed;
        }
    }



    tidalData.values.forEach(td => {
        if (stixGroups[td.meta.group_attack_id]) {
            stixGroups[td.meta.group_attack_id].observed_countries = td.meta.observed_countries;
            stixGroups[td.meta.group_attack_id].country = td.meta.country;

            if (td.meta.country) {
                originCountries[td.meta.country] = originCountries[td.meta.country] ? originCountries[td.meta.country] + 1 : 1;
                observedCountries[td.meta.country] = td.meta.observed_countries;
                updateMax(originCountries[td.meta.country]);
            }


            console.log("!!!! Contained in Stix");
            console.log(td);
        } else {
            console.warn("============= Not contained in Stix");
            console.log(td);
        }
    })
}


function addCov() {

    const d = document.createElement("div");
    d.id = "container";
    d.className =  "left-1/2 -translate-x-1/2 absolute h-full w-[60%]";
    // d.innerHTML = <div id="container"></div>
    // document.getElementById("mainctr").appendChild(d);
    document.getElementById("svgContainer").replaceWith(d)

    setTimeout(() => {
        Highcharts.chart('container', getBubble());
    })

}


function openModal() {


    svgContainer = document.getElementById("svgContainer")


    if (!svgLoaded) {
        fetch('world.svg')
            .then(res => res.text())
            .then(svgText => {
                svgContainer.innerHTML = svgText;
                svgLoaded = true;
                enableZoom("countrySvg");
                attachCountryClickHandlers();
            })
            .catch(err => {
                svgContainer.innerHTML = "<p class='text-error'>Failed to load map.</p>";
                console.error(err);
            });
    }
}

function addAttackBtn() {
    svgLoaded = false;
    const d = document.createElement("div");
    d.id = "svgContainer";
    d.className =  "w-full h-full  rounded overflow-y-hidden  overflow-x-hidden grid content-center";
    document.getElementById("container").replaceWith(d);
    setTimeout(() => {
        openModal();
    })
    // <div id="svgContainer" class="w-full h-full  rounded overflow-y-hidden  overflow-x-hidden grid content-center">
}

load().then(l => {
    enableDragging();
    openModal();
    const attBtn = document.getElementById('attackbtn');
    const covbtn = document.getElementById('covid');
    document.getElementById('covid').addEventListener('click', (evt) => {
        covbtn.classList.toggle('btn-outline');
        attBtn.classList.toggle('btn-outline');

        addCov();
    });

    document.getElementById('attackbtn').addEventListener('click', () => {
        attBtn.classList.toggle('btn-outline');
        covbtn.classList.toggle('btn-outline');
        addAttackBtn();
    });


})

let selectedCountry = ""

function selectCountry(name, path) {
    // console.log(name);
    input2.value = name;
    selectedCountry = name;
    path.style.fill = `#60a5fa`
    // modal.close();
}


function attachCountryClickHandlers() {
    const paths = svgContainer.querySelectorAll('path[id]');

    const cntryPaths = {};

    paths.forEach(path => {
        path.classList.add('cursor-pointer');
        // path.style.stroke = "#fff";
        const id = path.getAttribute("id");
        cntryPaths[id] = path;

        path.style.fill = `rgb(${Math.floor((originCountries[id] ? (originCountries[id] / maxGroupsInACountry) : 0) * 156 + (originCountries[id] ? 100 : 0))}, 0, 0)`




        // Hover events
        path.addEventListener('mouseover', e => {
            const title = path.getAttribute("title");
            input2.value = title;
        });


        path.addEventListener('mouseout', () => {
            input2.value = selectedCountry;
        });

        // Click event
        path.addEventListener('click', () => {
            console.log(path);
            const title = path.getAttribute("title");
            selectCountry(title, path);
        });
    });
    //
    const svgEL = svgContainer.querySelector("svg");

    // Object.keys(observedCountries).forEach(pId => {
    //     if (observedCountries[pId]) {
    //         observedCountries[pId].forEach(observedCountry => {
    //                     setTimeout(() => {
    //                 addAttack(svgEL, cntryPaths[pId], cntryPaths[observedCountry], `${pId}${observedCountry}`);
    //             }, Math.floor(Math.random()*1000) + 10)
    //         })
    //     }
    // })

}

const industries = [
    "Academic", "Aerospace", "Agriculture", "Architectural and Engineering", "Automotive",
    "Aviation", "Biomedical", "Chemicals", "Computer Gaming", "Consulting and Professional Services",
    "Consumer Goods", "Cryptocurrency", "Defense", "Dissident", "eCommerce", "Emergency Services",
    "Energy", "Entertainment", "Extractive", "Financial Management & Hedge Funds", "Financial Services",
    "Food and Beverage", "Government", "Healthcare", "Hospitality", "Hospitals and Clinics",
    "Industrials and Engineering", "Insurance", "International Government", "Law Enforcement", "Legal",
    "Local Government", "Logistics", "Manufacturing", "Maritime", "Mass Transit and Passenger Rail",
    "Media", "Military", "National Government", "NGO", "Nonprofit", "Nuclear", "Oil and Gas",
    "Opportunistic", "Ore and Metal Extraction", "Pharmaceutical", "Political Parties",
    "Primary and Secondary Education", "Real Estate", "Research Entities", "Retail", "Social Media",
    "Software", "Sports Organizations", "Technology", "Telecom Services", "Telecommunications",
    "Think Tanks", "Transportation", "Travel", "Utilities", "Vocational and Higher-Level Education"
];

const input = document.getElementById('autocomplete');
const suggestions = document.getElementById('suggestions');
let activeIndex = -1;
let filtered = [];
const columns = 3;

input.addEventListener('click', () => {
    industries.forEach((item, index) => {
        const div = document.createElement('div');
        div.textContent = item;
        div.className = 'p-2 cursor-pointer hover:bg-base-300 rounded';
        div.dataset.index = index;
        div.addEventListener('click', () => {
            input.value = item;
            suggestions.classList.add('hidden');
        });
        suggestions.appendChild(div);
    });
    suggestions.classList.remove('hidden');
});

input.addEventListener('input', () => {
    const query = input.value.toLowerCase();
    suggestions.innerHTML = '';
    activeIndex = -1;

    if (!query) {
        suggestions.classList.add('hidden');
        return;
    }

    filtered = industries.filter(item => item.toLowerCase().includes(query));

    filtered.forEach((item, index) => {
        const div = document.createElement('div');
        div.textContent = item;
        div.className = 'p-2 cursor-pointer hover:bg-base-300 rounded';
        div.dataset.index = index;
        div.addEventListener('click', () => {
            input.value = item;
            suggestions.classList.add('hidden');
        });
        suggestions.appendChild(div);
    });

    suggestions.classList.toggle('hidden', filtered.length === 0);
});

input.addEventListener('keydown', (e) => {
    const items = suggestions.querySelectorAll('div');
    if (items.length === 0) return;

    const rows = Math.ceil(items.length / columns);

    const col = activeIndex % columns;
    const row = Math.floor(activeIndex / columns);

    if (e.key === 'ArrowDown') {
        activeIndex = (activeIndex + columns) % items.length;
    } else if (e.key === 'ArrowUp') {
        activeIndex = (activeIndex - columns + items.length) % items.length;
    } else if (e.key === 'ArrowRight') {
        activeIndex = (activeIndex + 1) % items.length;
    } else if (e.key === 'ArrowLeft') {
        activeIndex = (activeIndex - 1 + items.length) % items.length;
    } else if (e.key === 'Enter') {
        if (activeIndex >= 0) {
            input.value = items[activeIndex].textContent;
            suggestions.classList.add('hidden');
            e.preventDefault();
            return;
        }
    }

    items.forEach((el, idx) => {
        el.classList.toggle('bg-base-300', idx === activeIndex);
    });

    if (activeIndex >= 0) {
        items[activeIndex].scrollIntoView({block: 'nearest'});
    }
});
